// Registrazione unica dei componenti Chart.js usati dalla dashboard.
// Importare questo modulo (side-effect) prima di renderizzare qualsiasi grafico.
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  LineController,
  DoughnutController,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  LineController,
  DoughnutController,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler
);

export const EURO_FORMAT = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});
